import Tracker from '@openreplay/tracker';

interface Instrumentation {
  openReplay: Tracker | null;
}

export const Instrumentation: Instrumentation = {
  openReplay: null,
};
